module.exports = __webpack_public_path__ + "img/bgTitle8.696919d1.png";